import React, { useState } from 'react';
import { Plus, Trash2, Edit2, Save, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import { adminApi, API_ENDPOINTS } from './api';
import { ImageUploader } from './ImageUploader';

const TeamForm = ({ item, onSave, onCancel }) => {
  const [f, setF] = useState({
    name: item?.name || '', position: item?.position || '', expertise: item?.expertise || '',
    bio: item?.bio || '', image: item?.image || '', section: item?.section || 'leadership',
  });
  const up = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 mb-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-bold text-gray-900">{item ? 'Modifier' : 'Nouveau membre'}</h3>
        <button onClick={onCancel}><X className="w-5 h-5 text-gray-400" /></button>
      </div>
      <form onSubmit={e => { e.preventDefault(); onSave(f); }} className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs text-gray-500">Nom *</Label><Input value={f.name} onChange={e => up('name', e.target.value)} required className="h-9" /></div>
          <div><Label className="text-xs text-gray-500">Poste *</Label><Input value={f.position} onChange={e => up('position', e.target.value)} required className="h-9" /></div>
        </div>
        <div><Label className="text-xs text-gray-500">Expertise</Label><Input value={f.expertise} onChange={e => up('expertise', e.target.value)} className="h-9" /></div>
        <div><Label className="text-xs text-gray-500">Biographie</Label><Textarea value={f.bio} onChange={e => up('bio', e.target.value)} rows={2} /></div>
        <ImageUploader value={f.image} onChange={v => up('image', v)} label="Photo" compact />
        <div>
          <Label className="text-xs text-gray-500">Section</Label>
          <select value={f.section} onChange={e => up('section', e.target.value)} className="w-full h-9 px-3 rounded-lg border border-gray-200 text-sm">
            <option value="board">Conseil d'Administration</option>
            <option value="leadership">Direction</option>
          </select>
        </div>
        <div className="flex gap-2">
          <Button type="submit" className="bg-gray-900 hover:bg-gray-800 h-9 rounded-lg text-sm"><Save className="w-4 h-4 mr-1.5" />Sauvegarder</Button>
          <Button type="button" variant="outline" onClick={onCancel} className="h-9 rounded-lg text-sm">Annuler</Button>
        </div>
      </form>
    </div>
  );
};

export const TeamTab = ({ team, onReload, onReloadStats }) => {
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState(false);

  const reset = () => { setEdit(null); setForm(false); };
  const open = (item = null) => { setEdit(item); setForm(true); };

  const saveTeam = async (d) => {
    try {
      if (edit) await adminApi.put(API_ENDPOINTS.adminTeamId(edit.id), d);
      else await adminApi.post(API_ENDPOINTS.adminTeam, d);
      toast.success('OK');
      reset();
      onReload();
      onReloadStats();
    } catch (err) {
      console.error('Save team failed:', err);
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  const delTeam = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      await adminApi.del(API_ENDPOINTS.adminTeamId(id));
      toast.success('Supprime');
      onReload();
      onReloadStats();
    } catch (err) {
      console.error('Delete team member failed:', err);
      toast.error('Erreur lors de la suppression');
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Equipe ({team.length})</h1>
        <Button onClick={() => open()} className="bg-gray-900 hover:bg-gray-800 text-sm h-9 rounded-lg">
          <Plus className="w-4 h-4 mr-1.5" />Ajouter
        </Button>
      </div>
      {form && <TeamForm item={edit} onSave={saveTeam} onCancel={reset} />}
      {['board', 'leadership'].map(sec => (
        <div key={sec}>
          <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
            {sec === 'board' ? "Conseil d'Administration" : "Direction"}
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {team.filter(m => m.section === sec).map(m => (
              <div key={m.id} className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 group hover:shadow-sm transition-all">
                <img src={m.image || '/images/logo-hpd.png'} alt="" className="w-11 h-11 object-cover rounded-full flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-gray-900 text-sm truncate">{m.name}</h4>
                  <p className="text-xs text-gray-500 truncate">{m.position}</p>
                </div>
                <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button onClick={() => open(m)} className="p-1.5 rounded-lg hover:bg-gray-100"><Edit2 className="w-3.5 h-3.5 text-gray-500" /></button>
                  <button onClick={() => delTeam(m.id)} className="p-1.5 rounded-lg hover:bg-red-50"><Trash2 className="w-3.5 h-3.5 text-red-400" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
